module.exports = __webpack_public_path__ + "static/media/kocka3IPADRAM.8e4a81ec.png";